import * as yup from 'yup';

import { ValidationError } from 'src/enums/Validation';
import { getMaxFieldLengthErrorMessage } from 'src/utils/validation';

export type SendInviteAgainFormData = {
  message: string;
};

export const validationFields = {
  message: yup
    .string()
    .trim()
    .default('')
    .max(500, getMaxFieldLengthErrorMessage(500))
    .required(ValidationError.default)
    .label('Message'),
};

export const validationSchema = yup.object(validationFields);

export const initialValues: SendInviteAgainFormData = validationSchema.getDefault();

export const attributesToSubmit = (values: SendInviteAgainFormData): SendInviteAgainFormData => values;
